$(document).ready(
    function () {

        const modalId = "order-notification-modal";
        const shownInputIds = new Set();

        function getQuantity(value) {
            let quantity = parseInt(value, 10);
            return isNaN(quantity) ? 0 : quantity;
        }

        function getModal() {
            let modal = $("#" + modalId);
            if (modal.length) {
                return modal;
            }

            modal = $(
                '<div class="modal fade" id="' + modalId + '" tabindex="-1" role="dialog" aria-labelledby="' + modalId + '-title" aria-hidden="true">' +
                '<div class="modal-dialog modal-dialog-centered" role="document">' +
                '<div class="modal-content">' +
                '<div class="modal-header"><h5 class="modal-title" id="' + modalId + '-title"></h5></div>' +
                '<div class="modal-body order-notification-modal-body"></div>' +
                '<div class="modal-footer"><button type="button" class="btn btn-primary" data-dismiss="modal"></button></div>' +
                '</div></div></div>'
            );
            modal.appendTo("body");
            return modal;
        }

        function showOrderNotification(input) {
            let modal = getModal();
            // .text() only: the message is organizer input and must never be rendered as HTML.
            $(".modal-title", modal).text(input.attr("data-name") || "");
            $(".modal-body", modal).text(input.attr("data-order-notification"));
            $(".modal-footer .btn", modal).text(input.attr("data-order-notification-ok"));
            modal.modal({backdrop: "static", show: true});
        }

        function handleQuantityChange(input) {
            let inputId = input.attr("id");
            if (!inputId || !input.attr("data-order-notification")) {
                return;
            }

            let previousQuantity = input.data("order-notification-last-quantity");
            if (previousQuantity === undefined) {
                // The value attribute holds the quantity rendered by the server. A reserved quantity means
                // the customer already picked this category earlier in the order, so don't notify again.
                previousQuantity = getQuantity(input.attr("value"));
                if (previousQuantity > 0) {
                    shownInputIds.add(inputId);
                }
            }
            let newQuantity = getQuantity(input.val());
            input.data("order-notification-last-quantity", newQuantity);

            if (previousQuantity !== 0 || newQuantity < 1 || shownInputIds.has(inputId)) {
                return;
            }

            shownInputIds.add(inputId);
            showOrderNotification(input);
        }

        $(document).on("ticket-quantity-changed change", "input.ticket-to-order[data-order-notification]", function () {
            handleQuantityChange($(this));
        });

    }
);
